import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createCustomBlockSpec } from '../../routines/createCustomBlockSpec.js';
import { handleInlineEnter } from '../../routines/handleInlineEnter.js';
import { LANGUAGES } from './constants.js';
import { LanguageSelect } from './LanguageSelect.js';
import { theme } from './theme.js';
import { langNames, langs } from '@uiw/codemirror-extensions-langs';
import ReactCodeMirror from '@uiw/react-codemirror';
import { Fragment, useCallback, useMemo } from 'react';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CodeMirror = ReactCodeMirror;
const blockConfig = {
    content: 'none',
    propSchema: {
        code: {
            default: '',
        },
        language: {
            default: 'typescript',
            values: langNames,
        },
    },
    type: 'codeblock',
};
const CodeBlockElement = ({ code, id, language, }) => {
    const extensions = useMemo(() => {
        return [langs[language]()];
    }, [language]);
    if (typeof window === 'undefined') {
        return (_jsx("pre", { style: {
                backgroundColor: '#f5f6f9',
                borderRadius: 10,
                color: '#14171f',
                fontFamily: 'Menlo, Monaco, Consolas, "Andale Mono", "Ubuntu Mono", "Courier New", monospace',
                fontSize: 14,
                lineHeight: '19.6px',
                overflowX: 'hidden',
                padding: '16px 14px 16px 18px',
                whiteSpace: 'pre',
                width: '100%',
            }, children: code.split('\n').map((line, index) => (_jsxs(Fragment, { children: [_jsx("span", { children: line }), _jsx("br", {})] }, index))) }));
    }
    return (_jsx("div", { className: "contra-cm-container", children: _jsx(CodeMirror, { autoFocus: true, basicSetup: {
                autocompletion: false,
                highlightActiveLine: false,
                highlightActiveLineGutter: false,
                highlightSelectionMatches: false,
                history: false,
                lineNumbers: false,
                tabSize: 2,
            }, className: "disabled", editable: false, extensions: extensions, id: id, style: { resize: 'none' }, theme: theme, value: code, width: "100%" }) }));
};
const EditableCodeBlockElement = ({ block, editor, }) => {
    const { code, language } = block.props;
    const extensions = useMemo(() => {
        return [langs[language]()];
    }, [language]);
    const handleInputChange = useCallback((value) => {
        editor.updateBlock(block, {
            props: { code: value },
        });
    }, [block, editor]);
    const handleSelectLanguage = useCallback((newValue) => {
        editor.updateBlock(block, {
            props: {
                language: newValue,
            },
        });
    }, [block, editor]);
    return (_jsxs("div", { className: "contra-cm-container", children: [_jsx(CodeMirror, { autoFocus: true, basicSetup: {
                    autocompletion: false,
                    highlightActiveLine: false,
                    highlightActiveLineGutter: false,
                    highlightSelectionMatches: false,
                    history: false,
                    lineNumbers: false,
                    tabSize: 2,
                }, className: editor.isEditable ? '' : 'disabled', editable: editor.isEditable, extensions: extensions, id: block.id, onChange: handleInputChange, onKeyDown: (event) => handleInlineEnter({ block, editor, event, requireShiftKey: true }), style: { resize: 'vertical' }, theme: theme, value: code, width: "100%" }), _jsx(LanguageSelect, { onSelect: handleSelectLanguage, selectedLanguage: LANGUAGES[language] })] }));
};
export const CodeBlock = createCustomBlockSpec(blockConfig, {
    render: (props) => {
        if (props.readOnly) {
            return (_jsx(CodeBlockElement, { code: props.block.props.code, id: props.block.id, language: props.block.props.language }));
        }
        return (_jsx(EditableCodeBlockElement, { block: props.block, editor: props.editor }));
    },
    toExternalHTML: ({ block }) => {
        return (_jsx("pre", { children: _jsx("code", { children: block?.props?.code }) }));
    },
});
//# sourceMappingURL=CodeBlock.js.map